var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M233.734 85.414c-62.018 16.682-86.271 21.91-166.158 42.854-5.425-.097-16.534-.928-21.671-9.508-4.759-5.92-9.704.68-9.438 6.742.365 8.334.598 15.292 4.48 19.201 21.665 19.95 29.079 41.322 32.223 65.74-.33 5.212-4.623 10.003 3.193 9.649 7.87-.584 84.264-6.63 140.414-1.694 4.642.477 5.46-3.68 5.15-5.39-2.642-14.616 24.34-61.362 33.376-80.475 1.862-3.939 11.818-4.434 13.933-4.94-.139.036 2.862-1.724 1.096-3.913-10.719-13.288-32.865-39.444-36.598-38.266Zm-21.277 34.902c9.087.07 13.42 2.431 9.83 8.35-11.115 22.31-24.243 65.936-28.215 65.264-61.306-.42-87.927 4.061-94.015 2.047-2.2-.816-5.412-24.9-19.333-42.18-2.19-2.718-1.287-4.696 2.254-5.557 20.629-4.616 99.796-28.148 129.479-27.924z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-1.128 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.91 395.105c.375 4.16-.176 12.407 6.29 14.786 5.617.585 19.754 11.446 16.955 28.57.093 187.928 3.323 200.165.313 345.458-5.626 52.577 6.734 80.47 10.822 86.966 2.936 6.59 6.127 5.517 7.604 1.438 12.98-35.82 18.661-12.554 14.702-102.902-.58-150.139-2.886-315.647 19.067-327.81 8.67-6.963 20.055-28.689 17.348-33.728 3.103-4.975-50.622-54.04-55.126-49.497-7.368 8.04-36.646 21.96-37.975 36.719z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-168.708 -271.196) scale(.7641)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChun);
export default __webpack_public_path__ + "static/media/Chun.969cbef6b1250d9acf24328de304fa89.svg";
export { ForwardRef as ReactComponent };